import useForm from 'hooks/useForm'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { selectCurrentBalance } from '../../../../accessors/index'
import CurrencyInput from '../../../../components/ReusableComponents/CurrencyInput/index'
import styles from './MakeHotelCreditPayment.module.scss'

const MakeHotelCreditPayment = ({ handleSubmit, goBackPath }) => {
  const balance = useSelector(selectCurrentBalance)

  const amount = balance > 0 ? balance : 0

  // eslint-disable-next-line no-unused-vars
  const [values, _handleChange, setValue] = useForm({
    amount
  })

  const firstRenderRef = useRef(true)

  const [amountValue, setAmountValue] = useState(`$${Number(values.amount).toFixed(2)}`)
  const [paymentNotes, setPaymentNotes] = useState('')

  useEffect(() => {
    if (!firstRenderRef.current) {
      setAmountValue(values.amount)
    }
  }, [values.amount])

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false
    }
  }, [])

  const [isValid, setIsValid] = useState()

  useEffect(() => {
    setIsValid(values.amount > 0 && paymentNotes.length > 0)
  }, [values, paymentNotes])

  useEffect(() => {
    setValue({ amount: amountValue.replace(/[$,]/gi, '') })
  }, [amountValue, setValue])

  const { amount: PaymentAmount } = values

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.inputHolder}>
          <label className={styles.currencyLabel}>
            <span className={styles.currencyLabelText}>Credit amount</span>
            <CurrencyInput
              onChange={e => setAmountValue(e.target.value)}
              value={amountValue}
              className={styles.currencyInput}
            />
          </label>
        </div>
        <div className={styles.inputHolder}>
          <label className={styles.currencyLabel}>
            <span className={styles.currencyLabelText}>Reason for adding credit</span>
            <input
              className={styles.textInput}
              value={paymentNotes}
              placeholder="Why are you adding credit?"
              onChange={e => setPaymentNotes(e.target.value)}
            />
          </label>
        </div>
      </div>
      <div className={styles.controls}>
        <Link to={goBackPath}>
          <button className={styles.secondaryButton}>Cancel</button>
        </Link>
        <button
          disabled={!isValid}
          onClick={() =>
            handleSubmit({
              PaymentMethod: 'HotelCredit',
              PaymentNotes: paymentNotes,
              PaymentAmount
            })
          }
          className={styles.primaryButton}
        >
          Save &amp; confirm payment
        </button>
      </div>
    </div>
  )
}

export default MakeHotelCreditPayment
